import { render, staticRenderFns } from "./CompanyManagement.vue?vue&type=template&id=be91e70e&scoped=true&"
import script from "./CompanyManagement.vue?vue&type=script&lang=js&"
export * from "./CompanyManagement.vue?vue&type=script&lang=js&"
import style0 from "./CompanyManagement.vue?vue&type=style&index=0&id=be91e70e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be91e70e",
  null
  
)

export default component.exports